// =============================================================
// 滚动渐入（全局，支持路由切换后重新扫描）· Vue 2 适配
// 使用 IntersectionObserver 实现 fade-in + up 20px
// 说明：
//   - 视口内或即将进入视口（提前 1.2x 视口高）的元素直接显示，避免白屏；
//   - IntersectionObserver 带 rootMargin 提前触发，内容更早出现；
//   - 路由懒加载后通过 MutationObserver 重新扫描，视口内立即显示。
//   在组件的 mounted 中调用 useReveal()，在 beforeDestroy 中调用 destroy()。
// =============================================================
import Vue from 'vue'

export function useReveal() {
  let observer = null
  let mutationObserver = null

  const revealNow = (el) => el.classList.add('is-visible')

  // 判定：元素是否已在视口内或即将进入视口（top < 视口高 * 1.2）
  const isNearViewport = (el) => {
    const r = el.getBoundingClientRect()
    const vh = window.innerHeight || document.documentElement.clientHeight
    return r.top < vh * 1.2 && r.bottom > 0
  }

  const observeAll = () => {
    document.querySelectorAll('.reveal:not(.is-visible)').forEach((el) => {
      // 已在视口内或即将进入视口的直接显示，避免白屏
      if (isNearViewport(el)) {
        revealNow(el)
        return
      }
      if (!el.dataset.revealBound) {
        el.dataset.revealBound = '1'
        observer.observe(el)
      }
    })
  }

  const init = () => {
    Vue.nextTick(() => {
      if (typeof IntersectionObserver === 'undefined') {
        document.querySelectorAll('.reveal').forEach(revealNow)
        return
      }

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              revealNow(entry.target)
              observer.unobserve(entry.target)
            }
          })
        },
        { threshold: 0.05, rootMargin: '0px 0px 120px 0px' }
      )

      observeAll()

      // 监测新增 .reveal 元素（路由切换懒加载后）
      mutationObserver = new MutationObserver(() => {
        observeAll()
      })
      mutationObserver.observe(document.body, { childList: true, subtree: true })

      // 兜底：稍后再扫一次，确保视口内的都能显示
      setTimeout(observeAll, 150)
    })
  }

  const destroy = () => {
    if (observer) observer.disconnect()
    if (mutationObserver) mutationObserver.disconnect()
  }

  return { init, destroy }
}



// WEBPACK FOOTER //
// ./src/site/composables/useReveal.js